import { cva } from "./index.ts";

export const float = cva({
  base: "rounded-md shadow-lg p-6 bg-white z-20",
});
